import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SAMLLoginComponent } from './saml-login/saml-login.component';
import { LoginUserComponent } from './login-user/login-user.component';
import { GuestUserComponent } from './guest-user/guest-user.component';
import { AuthenticationService } from './services/authentication.service';
import { RestInterceptor } from './_helpers/rest.interceptor';
import { SafePipe } from './_helpers/safe.pipe';
import { ECMService } from './services/ecm.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { PublicUserComponent } from './public-user/public-user.component';

export function initConfig(config: AppConfig) {
  return () => config.load();
}

@NgModule({
  declarations: [
    AppComponent,
    SAMLLoginComponent,
    LoginUserComponent,
    GuestUserComponent,
    PublicUserComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RestInterceptor, multi: true },
    AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfig],
            multi: true
        },
    AuthenticationService,
    ECMService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
